
<template>
    <div>
        <CRow class="mb-3 ml-2">
            <h3>사용자등록</h3>
        </CRow>
        <form style="width: 100%">
            <CRow>
                <CCol md="8">
                    <CCard>
                        <CCardHeader>
                            <strong>사용자정보</strong>
                        </CCardHeader>
                        <CCardBody>
                            <CForm>
                                <CRow style="margin-bottom: 20px;">
                                    <div class="col-sm-4">
                                        <label class=""> 단체명 </label>
                                        <template>
                                            <template>
                                                <select  class="form-control" :required="true" @change="changeCompany($event)">
                                                    <option v-for="option in companyList" v-bind:value="option.companyId" >{{ option.name }}</option>
                                                </select>
                                            </template>
                                        </template>
                                    </div>
                                    <CCol sm="4">
                                        <label  class=""> 권한 </label>
                                        <template>
                                            <template>
                                                <select class="form-control" :required="true" v-model="roleGroup">
                                                    <option value="M" selected>마스터</option>
                                                    <option value="C">단체</option>
                                                </select>
                                            </template>
                                        </template>
                                    </CCol>
                                    <CCol sm="4">
                                        <label  class=""> 활성화 </label>
                                        <template>
                                            <template>
                                                <select class="form-control" :required="true" v-model="enabledYn">
                                                    <option value="Y" selected>활성화</option>
                                                    <option value="N">비활성화</option>
                                                </select>
                                            </template>
                                        </template>
                                    </CCol>
                                </CRow>
                                <CInput
                                        label="로그인ID"
                                        description="로그인ID"
                                        placeholder="로그인ID"
                                        horizontal
                                        v-model="loginId"
                                        required
                                        was-validated
                                />
                                <CInput
                                        label="로그인 패스워드"
                                        placeholder="로그인 패스워드"
                                        description="로그인 패스워드"
                                        horizontal
                                        v-model="loginPwd"
                                        required
                                        was-validated
                                />
                             <!--   <CInput
                                        type="password"
                                        label="로그인 패스워드 확인"
                                        placeholder="로그인 패스워드 확인"
                                        description="로그인 패스워드 확인"
                                        horizontal
                                        v-model="loginPwdConf"
                                        required
                                        was-validated
                                />-->

                                <CInput
                                        label="이름"
                                        placeholder="이름"
                                        description="이름"
                                        horizontal
                                        v-model="name"
                                        required
                                        was-validated
                                />
                                <CInput
                                        label="연락처"
                                        placeholder="연락처"
                                        description="연락처"
                                        horizontal
                                        v-model="phone"
                                        required
                                        was-validated
                                />
                                <CInput
                                        label="이메일"
                                        placeholder="이메일"
                                        description="이메일"
                                        horizontal
                                        v-model="email"
                                        required
                                        was-validated
                                />
                                <CInput
                                        label="메모"
                                        placeholder="메모"
                                        description="메모"
                                        horizontal
                                        v-model="memo"
                                        required
                                        was-validated
                                />
                            </CForm>
                        </CCardBody>
                        <CCardFooter>
                            <CButton type="button" size="sm" color="primary"   @click="submit"><CIcon name="cil-check-circle"/> 저장</CButton>
                        </CCardFooter>
                    </CCard>
                </CCol>
            </CRow>
        </form>
    </div>
</template>
<style>
    .btn-col-margin{
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 10px;
    }
    .col-title{
        width: 20%;
    }
    .table-span-margin{
        margin-left: 10%;
    }
</style>
<script>
    import Vue from 'vue'
    import axios from "axios";
    import VueMoment from 'vue-moment'

    Vue.use(VueMoment)

    export default {
        name: 'paymanageupdate',
        components: {
        },
        data() {
            return{
                optionsRole: ['마스터', '단체'],
                optionsEnabled: ['사용', '사용중지'],
                companyList:[],
                insertTime:'',
                enabledYn:'Y',
                loginId:'',
                loginPwd:'',
                loginPwdConf:'',
                roleGroup:'C',
                memo:'',
                phone:'',
                name:'',
                email:'',
            }
        },
        mounted() {
            axios.post('silver/getCompanyAll')
                .then(res => {
                    console.log(res.data.companyList);
                    this.companyList = res.data.companyList;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        methods: {
            submit () {
                if(this.insertTime == 'Invalid date'){
                    this.insertTime = ''
                }

               /* var password = this.loginPwd;
                var passwordConfirm = this.loginPwdConf;
                if(password === passwordConfirm){*/
                    axios.post('/silver/admin/insert', {
                        enabledYn:this.enabledYn,
                        companyId:this.companyId,
                        enabledYn:this.enabledYn,
                        loginId:this.loginId,
                        loginPwd:this.loginPwd,
                        roleGroup:this.roleGroup,
                        memo:this.memo,
                        phone:this.phone,
                        name:this.name,
                        email:this.email,
                    })
                    .then(data => {
                        this.$router.push({name:"adminlist"})
                    })
                    .catch(function (error) {
                        console.log(error)
                    });
               /* } else {
                    alert("비밀번호를 확인해주세요.");
                }*/
            },
            changeCompany(event) {
                console.log(event.target.value)
                this.companyId = event.target.value
            }
        }
    }
</script>
